import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { MsalAuthenticationTemplate } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { loginRequest } from "@/authConfig";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import EstimateForm from "@/pages/EstimateForm";
import InvoiceView from "@/pages/InvoiceView";
import ConsolidatedInvoices from "@/pages/ConsolidatedInvoices";
import MonthlyConsumption from "@/pages/MonthlyConsumption";

function LoadingComponent() {
  return (
    <div className="min-h-screen bg-black flex items-center justify-center">
      <div className="text-center">
        <div className="w-12 h-12 border-2 border-[#A80097] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-zinc-400 text-sm">Signing in...</p>
      </div>
    </div>
  );
}

function ErrorComponent({ error }) {
  return (
    <div className="min-h-screen bg-black flex items-center justify-center">
      <div className="text-center max-w-md px-6">
        <p className="text-red-400 text-lg font-semibold mb-2">Authentication Failed</p>
        <p className="text-zinc-500 text-sm">{error?.message || "An error occurred during sign-in."}</p>
      </div>
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <MsalAuthenticationTemplate
        interactionType={InteractionType.Redirect}
        authenticationRequest={loginRequest}
        loadingComponent={LoadingComponent}
        errorComponent={ErrorComponent}
      >
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/consumption" element={<MonthlyConsumption />} />
              <Route path="/estimate/new" element={<EstimateForm />} />
              <Route path="/estimate/:id" element={<EstimateForm />} />
              <Route path="/invoices" element={<ConsolidatedInvoices />} />
              <Route path="/invoices/:id" element={<InvoiceView />} />
            </Routes>
          </Layout>
        </BrowserRouter>
      </MsalAuthenticationTemplate>
    </div>
  );
}

export default App;
